import { render, staticRenderFns } from "./HighChartsBarColumn.vue?vue&type=template&id=5b179e6a&"
import script from "./HighChartsBarColumn.vue?vue&type=script&lang=js&"
export * from "./HighChartsBarColumn.vue?vue&type=script&lang=js&"
import style0 from "./HighChartsBarColumn.vue?vue&type=style&index=0&id=5b179e6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports